export const countryMarketMapping = {
  AU: 'APAC', // Australia
  IN: 'APAC', // India
  ID: 'APAC', // Indonesia
  MY: 'APAC', // Malaysia
  NZ: 'APAC', // New Zealand
  PH: 'APAC', // Philippines
  SG: 'APAC', // Singapore
  TH: 'APAC', // Thailand
  VN: 'APAC', // Vietnam
  DK: 'EMEA', // Denmark
  FI: 'EMEA', // Finland
  IE: 'EMEA', // Ireland
  NO: 'EMEA', // Norway
  GB: 'UK', // United Kingdom // GB belongs to EMEA, use UK here for feature convenient
  SE: 'EMEA', // Seeden
  US: 'NA', // United States
  CA: 'NA', // Canada
  DE: 'LATAM', // Germany
  AT: 'LATAM', // Austria
  CH: 'LATAM', // Switerland
  ES: 'LATAM', // Spain
  MX: 'LATAM', // Mexico
  AR: 'LATAM', // Argentina
  CL: 'LATAM', // Chile
  CO: 'LATAM', // Colombia
  PE: 'LATAM', // Peru
  VE: 'LATAM', // Venezuela
  FR: 'LATAM', // France
  IT: 'LATAM', // Italy
  NL: 'LATAM', // Netherlands
  BR: 'LATAM', // Brazil
} as const;

export const i18nLanguageToDisaplyLanguage = {
  en: 'EN', // Australia, India, Malaysia, New Zealand, Philippines, Singapore, Ireland, United Kingdom, United States, Canada
  id: 'EN', // Indonesia
  th: 'EN', // Thailand
  vi: 'EN', // Vietnam
  da: 'EN', // Denmark
  fi: 'EN', // Finland
  nb: 'EN', // Norway
  sv: 'EN', // Sweden
  de: 'DE', // Germany, Austria, Switzerland,
  es: 'ES', // Spain, Mexico, Argentina, Chile, Colombia, Peru, Venezuela
  fr: 'FR', // France, Canada
  it: 'IT', // Italy
  nl: 'EN', // Netherlands
  pt: 'PT', // Brazil
  ja: 'JA', // Japan
  zh: 'ZH', // Taiwan, Hong Kong
} as const;

export type CountryCode = keyof typeof countryMarketMapping;
export type SupportMarket = (typeof countryMarketMapping)[CountryCode];
export type I18nLanguage = keyof typeof i18nLanguageToDisaplyLanguage;
export type DisplayLanguage = (typeof i18nLanguageToDisaplyLanguage)[I18nLanguage];
